import React from "react";
import AdminNav from "../../navigation/AdminNav";
import { Link } from "react-router-dom";

/**
 * This page presents the lecturer with a form that is populated with 5 different buttons.
 * When a button is pressed it will then redirect the user to the corresponding page that is linked to that button.
 * @returns a form with 5 buttons
 */

function AdminHomepage() {
    return(
        <div className="adminHomepageContainer">
            <AdminNav />
            <form>
                <h1 style={{textAlign: "center"}}>Home Page</h1>
                <div className="buttonGrid paper">
                    <Link to="/adminDates">
                        <button className="homeButton" type="button">
                            Choose Dates
                        </button>
                    </Link>
                    <Link to="/adminManageStudents">
                        <button className="homeButton" type="button">
                            Manage Student Projects
                        </button>
                    </Link>
                    <Link to="/adminManageLecturers">
                        <button className="homeButton" type="button">
                            Manage Lecturer Projects
                        </button>
                    </Link>
                    <Link to="/adminManageUsers">
                        <button className="homeButton" type="button">
                            Manage Users
                        </button>
                    </Link>
                <button className="homeButton" type="button">
                    Allocate Projects
                </button>
                </div>
            </form>
        </div>
    )
}

export default AdminHomepage